import { translate } from "app/filters/i18nFilter";
import { AI_AGENT_GMAIL_KB_ARTICLE_LINK, EXTENSION_LINK } from "app/pages/sales-intelligence/constants/common";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { isSalesExtensionPresent } from "app/pages/sales-intelligence/utils/extension";

import { StyledIconButton } from "./styles";

export const GmailActionButton = () => {
    const hasExtension = isSalesExtensionPresent();
    const href = hasExtension ? AI_AGENT_GMAIL_KB_ARTICLE_LINK : EXTENSION_LINK;

    // TODO: remove this after article is ready
    if (hasExtension) {
        return null;
    }

    const handleClick = () => {
        AIAgentTrackingService.email.trackGmailCTA(hasExtension);
        window.open(href, "_blank");
    };

    return (
        <StyledIconButton
            type="flat"
            iconName={hasExtension ? "Help-icon" : "gmail"}
            onClick={handleClick}
            data-automation="gmail-action-button"
        >
            <a
                href={href}
                target="_blank"
                rel="noreferrer"
            >
                {translate("si.pages.ai_agent_email.use_on_gmail")}
            </a>
        </StyledIconButton>
    );
};
